export default __webpack_public_path__ + "static/media/support.3a0c16b2.png";